// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i0eFs","controls":"styles_controls__YsS2W","charLimit":"styles_charLimit__38n_G","input":"styles_input__3BHdU","send":"styles_send__2M66W"};